module.exports = __webpack_public_path__ + "19c56aa9743eb6f90e22fce91ad3c7eb.jpg";